import React, {FunctionComponent, useState} from "react";
import {Grid, Box, Typography, Button, Container, List, ListItem, ListItemIcon, ListItemText, GlobalStyles} from "@mui/material";
import InputText from "@/Components/FormComponents/InputText/InputText";
import InputSelect from "@/Components/FormComponents/InputSelect/InputSelect";
import {useForm, useFormContext} from "react-hook-form";
import {useTranslation} from "@/Utils/CustomHooks/useTranslation";
import InputPassword from "@/Components/FormComponents/InputPassword/InputPassword";
import {
    UserTokenMainQueryRendererQueryResponse
} from "@/Domains/UserManagement/User/QueryRenderer/__generated__/UserTokenMainQueryRendererQuery.graphql";
import Logo from "@/Style/crentweb-logo.png";
import BackgroundImage from "@/Style/Background_crw_create_admin.png";
import {CheckCircleOutline} from "@mui/icons-material";
import { KeyboardArrowDown } from "@mui/icons-material";
import {useHistory} from "react-router-dom";
import InputPasswordCheck from "@/Components/FormComponents/InputPasswordCheck";


const imagePanelStyles = {
    minHeight: "100vh",
    width: "50%",
    boxSizing: "border-box",
    position: "relative",
    backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.6), rgba(0, 0, 0, 0.6)), url(${BackgroundImage})`,
    backgroundSize: "cover",
    backgroundPosition: "center",
    backgroundRepeat: "no-repeat",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    padding: "40px",
    color: "white",
    overflow: "hidden",
};

const formPanelStyles = {
    backgroundColor: "#ffffff",
    minHeight: "100vh",
    display: "flex",
    width: "50%",
    boxSizing: "border-box",
    flexDirection: "column",
    justifyContent: "center",
    padding: "40px",
    overflow: "hidden",
};

const formContainerStyles = {
    maxWidth: "600px",
    margin: "0 auto",
    width: "100%",
    overflow: "hidden",
};

const formLogoStyles = {
    backgroundImage: `url(${Logo})`,
    width: 161,
    height: 35,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    marginRight: "10px",
    color: "white",
    fontWeight: "bold",
    fontSize: "18px",
    float: "left",
};



interface ManagerUserTokenGeneralProps {
    viewData: UserTokenMainQueryRendererQueryResponse;
    token: any;
    onSubmit: any;
}

const ManagerUserTokenGeneral: FunctionComponent<ManagerUserTokenGeneralProps> = ({
                                                                            viewData,
    onSubmit,
                                                                        }): JSX.Element => {
    const { t } = useTranslation();

    const history = useHistory();
    const {
        handleSubmit,
        formState: {isDirty, dirtyFields, isSubmitting, isLoading, errors},
        watch
    } = useFormContext();

    const isFormDirty = (): boolean => {
        return isDirty && Object.keys(dirtyFields).length;
    }


    const languageItems = viewData?.languageList?.languages?.flatMap(
        (a: any) => ({
            id: a.language,
            name: a.language,
        }),
    ) || [];

    return (
         <>
             <Container maxWidth={false} disableGutters
                        sx={{
                 width: "100vw",
                 margin: 0,
                 padding: 0,
                 border: 0,
                 boxSizing: "border-box",

                 position: {
                     xs: "static",
                     md: "static",
                     lg: "fixed",
                 },

                 top: {
                     lg: 0,
                 },

                 left: {
                     lg: 0,
                 },

                 minHeight: "100vh",
             }}
             >

                 <Grid container >

                     <Grid item xs={12} md={6} lg={5} sx={imagePanelStyles}>
                         <Box sx={{ position: "absolute", top: "40px", left: "40px", zIndex: 2}}>
                             <Box
                                 sx={formLogoStyles}
                             >
                             </Box>
                         </Box>

                         <Box sx={{ zIndex: 2 }}>
                             <Typography variant="h3" fontWeight="bold" gutterBottom sx={{ mb: 4 }}>
                                 {t("userToken.fields.welcomeCrent")}
                             </Typography>

                             <Typography variant="body1" sx={{ opacity: 0.9, lineHeight: 1.6, fontSize: '1.1rem', mb: 4 }}>
                                 {t("userToken.fields.oneStep")}
                             </Typography>

                             <List sx={{ mt: 2 }}>
                                 <ListItem sx={{ mb: 2, color: "#ffffff" }}>
                                     <ListItemIcon sx={{ minWidth: 24,   width: 24,
                                         height: 24,
                                         borderRadius: "100%",
                                         backgroundColor: "#e42023",
                                         display: "flex",
                                         alignItems: "center",
                                         justifyContent: "center",
                                         color: "white",
                                         marginRight: 1
                                     }}>
                                         <CheckCircleOutline />
                                     </ListItemIcon>
                                     <ListItemText primary={t("userToken.fields.resAndDispo")} />
                                 </ListItem>
                                 <ListItem sx={{ mb: 2, color: "#ffffff" }}>
                                     <ListItemIcon sx={{  minWidth: 24,   width: 24,
                                         height: 24,
                                         borderRadius: "100%",
                                         backgroundColor: "#e42023",
                                         display: "flex",
                                         alignItems: "center",
                                         justifyContent: "center",
                                         color: "white",
                                         marginRight: 1}}>
                                         <CheckCircleOutline />
                                     </ListItemIcon>
                                     <ListItemText primary={t("userToken.fields.employeeAndRights")} />
                                 </ListItem>
                                 <ListItem sx={{ mb: 2, color: "#ffffff" }}>
                                     <ListItemIcon sx={{ minWidth: 24,   width: 24,
                                         height: 24,
                                         borderRadius: "100%",
                                         backgroundColor: "#e42023",
                                         display: "flex",
                                         alignItems: "center",
                                         justifyContent: "center",
                                         color: "white",
                                         marginRight: 1}}>
                                         <CheckCircleOutline />
                                     </ListItemIcon>
                                     <ListItemText primary={t("userToken.fields.masterdataAndConfiguration")} />
                                 </ListItem>
                             </List>
                         </Box>
                         <Box sx={{
                             position: "absolute",
                             bottom: "20px",
                             left: "50%",
                             transform: "translateX(-50%)",
                             animation: "bounce 2s infinite",
                             display: { xs: 'block', md: 'none' }
                         }}>
                             <KeyboardArrowDown fontSize="large" sx={{ color: "rgba(255,255,255,0.7)" }} />
                         </Box>
                     </Grid>
             <Grid item xs={12} md={6} lg={7} sx={formPanelStyles}>
             <Grid sx={formContainerStyles}>
                 <Typography variant="h5" fontWeight="bold" gutterBottom  >
                     {t("userToken.headlines.admindata")}
                 </Typography>
                 <Typography variant="body2" sx={{ color: "#666", mb: 4}}>
                     {t("userToken.headlineText.admindata")}
                 </Typography>
                    <Box component="form">

                    <Grid item xs={12}>
                        <InputText
                            label={t("userToken.fields.email")}
                            name={"email"}
                        />
                    </Grid>
                    <Grid container spacing={2}>
                        <Grid item xs={12} sm={6}>
                        <InputText
                            label={t("userToken.fields.firstname")}
                            name={"firstname"}
                        />
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <InputText
                                label={t("userToken.fields.lastname")}
                                name={"lastname"}
                            />
                        </Grid>
                    </Grid>
                    <Grid item xs={12}>
                        <InputPasswordCheck
                            label={t("userToken.fields.password")}
                            name={"password"}

                        />
                    </Grid>
                    <Grid item xs={12}>
                        <InputPassword
                            label={t("userToken.fields.confirmPassword")}
                            name={"passwordConfirm"}
                        />
                    </Grid>
                        <Grid container spacing={2}>
                            <Grid item xs={12}>
                                <InputSelect
                                    label={t("userToken.fields.language")}
                                    name={"language"}
                                    items={languageItems}
                                />
                            </Grid>
                        </Grid>
                    <Grid container spacing={2}>
                    <Grid item xs={12}>
                        <Button
                            type="submit"
                            variant="contained"
                            sx={{
                                width: "100%",
                                backgroundColor: "#E53935",
                                color: "white",
                                padding: "12px",
                                textTransform: "none",
                                fontWeight: "bold",
                                fontSize: "14px",
                                "&:hover": {
                                    backgroundColor: "#D32F2F",
                                },
                                mb: 2,
                                mt: 2
                            }}
                            onClick={handleSubmit((data) =>
                                onSubmit(
                                    data,
                                    false,
                                    () => {
                                        history.push("/login");
                                    },
                                    isFormDirty(),
                                ),
                            )}
                            isLoading={isLoading}
                            disabled={
                                isSubmitting ||
                                !isFormDirty()
                            }
                        >
                            {t("userToken.fields.createAdmin")}
                                    </Button>
                                </Grid>
                            </Grid>
                        </Box>
                     </Grid>
                  </Grid>
               </Grid>
             </Container>
         </>
    );
};

export default ManagerUserTokenGeneral;
